(function () {
  function getMoq() {
    return parseInt(document.body.dataset.customLogoMoq, 10) || 500;
  }

  function selectedOptionValues(container) {
    return Array.from(container.querySelectorAll('ul[data-option-index] .dl-selected'))
      .map(function (option) { return option.dataset.dlValue || ''; });
  }

  function selectedVariant(container) {
    var variantsJson = container.querySelector('[data-variants-json]');
    if (!variantsJson) return undefined;
    try {
      var variants = JSON.parse(variantsJson.textContent || '[]');
      var selected = selectedOptionValues(container);
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === selected[index];
        });
      }) || null;
    } catch (error) {
      return undefined;
    }
  }

  function syncVariantAvailability(container) {
    var variant = selectedVariant(container);
    if (variant === undefined || (variant && variant.available)) return;

    if (!variant) {
      var variantInput = container.querySelector('.product-variant-id');
      if (variantInput) variantInput.value = '';
    }

    var label = variant ? 'Sold Out' : 'Unavailable';
    [container.querySelector('.js-add-cart'), document.querySelector('[data-sticky-addtocart]')]
      .forEach(function (button) {
        if (!button) return;
        button.disabled = true;
        button.classList.add('is-disabled');
        button.classList.remove('bg-red');
        button.classList.add('bg-gray');
        var text = button.querySelector('.cart-btn-text');
        if (text && text.textContent !== label) text.textContent = label;
      });
  }

  function selectedPackSize(container) {
    var variantInput = container.querySelector('.product-variant-id');
    var unitsJson = container.querySelector('[data-variant-units]');
    if (variantInput && unitsJson) {
      try {
        var units = JSON.parse(unitsJson.textContent || '{}');
        var metafieldPackSize = parseInt(units[variantInput.value], 10);
        if (metafieldPackSize > 0) return metafieldPackSize;
      } catch (error) {
        // Fall back to the option label below.
      }
    }

    var match = selectedOptionValues(container).join(' ').match(/(\d+)\s*Units/i);
    return match ? parseInt(match[1], 10) : 1;
  }

  function isLogoPrinting(container) {
    return selectedOptionValues(container).some(function (value) {
      return /Logo Printing/i.test(value);
    });
  }

  function isClarxPreprinted(container) {
    return selectedOptionValues(container).some(function (value) {
      return /^Pre-printed with clarx$/i.test(value.trim());
    });
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'USD';
    var locale = document.documentElement.lang || 'en-US';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function updateAddToCartTotal(container) {
    var button = container.querySelector('.js-add-cart');
    var input = container.querySelector('[data-quantity-input]');
    if (!button || !input || button.disabled || button.classList.contains('is-loading')) return;

    var unitPrice = parseInt(button.dataset.unitPrice, 10);
    var quantity = parseInt(input.value, 10);
    if (!unitPrice || !quantity) return;

    var label = 'Add to Cart - ' + formatMoney(unitPrice * quantity);
    var buttonText = button.querySelector('.cart-btn-text');
    if (buttonText && /^(Adding|Added)/i.test(buttonText.textContent.trim())) return;
    if (buttonText && buttonText.textContent !== label) buttonText.textContent = label;

    var stickyButton = document.querySelector('[data-sticky-addtocart]');
    var stickyText = stickyButton && stickyButton.querySelector('.cart-btn-text');
    if (stickyText && !stickyButton.classList.contains('is-loading') && stickyText.textContent !== label) {
      stickyText.textContent = label;
    }
  }

  function updateVolumeDiscountNote(container) {
    var note = container.querySelector('[data-volume-discount-note]');
    var input = container.querySelector('[data-quantity-input]');
    if (!note || !input) return;

    var quantity = parseInt(input.value, 10) || 0;
    var shouldShow = !isClarxPreprinted(container) && selectedPackSize(container) === 50 && quantity >= 8;
    var wasHidden = note.hidden;
    note.hidden = !shouldShow;

    if (shouldShow && wasHidden) {
      note.classList.remove('is-emphasized');
      void note.offsetWidth;
      note.classList.add('is-emphasized');
    } else if (!shouldShow) {
      note.classList.remove('is-emphasized');
    }
  }

  function showProductError(container, message) {
    var addToCart = container.querySelector('[id^="AddToCart-"]');
    if (!addToCart) return;
    var error = container.querySelector('#cart-form-error');
    if (!error) {
      error = document.createElement('div');
      error.id = 'cart-form-error';
      error.className = 'cart-form-error';
      error.setAttribute('role', 'alert');
      error.setAttribute('aria-live', 'polite');
      addToCart.parentNode.insertBefore(error, addToCart);
    }
    error.textContent = message;
    error.classList.add('is-visible');
  }

  function syncProductMoq(container) {
    var input = container.querySelector('[data-quantity-input]');
    if (!input) return;

    if (!isLogoPrinting(container)) {
      updateAddToCartTotal(container);
      updateVolumeDiscountNote(container);
      return;
    }

    var minimumPacks = Math.ceil(getMoq() / selectedPackSize(container));
    input.min = String(minimumPacks);
    if ((parseInt(input.value, 10) || 0) < minimumPacks) {
      input.value = String(minimumPacks);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateAddToCartTotal(container);
    updateVolumeDiscountNote(container);
  }

  function validateProduct(container) {
    var variant = selectedVariant(container);
    if (variant === null || (variant && !variant.available)) {
      showProductError(container, 'This option combination is unavailable. Please choose another option.');
      return false;
    }
    if (!isLogoPrinting(container)) return true;
    var input = container.querySelector('[data-quantity-input]');
    var totalUnits = (parseInt(input && input.value, 10) || 0) * selectedPackSize(container);
    if (totalUnits >= getMoq()) return true;
    showProductError(container, 'Custom logo printing requires a minimum order of ' + getMoq() + ' units.');
    return false;
  }

  function clampCartInput(input) {
    var minimum = parseInt(input.dataset.minQty || input.dataset.min, 10) || 1;
    var quantity = parseInt(input.value, 10) || 0;
    if (quantity === 0 || quantity >= minimum) return;
    input.value = String(minimum);
    var line = input.dataset.line;
    var error = line && document.querySelector('#Line-item-error-' + line + ' .cart-item__error-text');
    if (error) error.textContent = 'Custom logo printing requires a minimum order of ' + getMoq() + ' units.';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var productContainer = document.querySelector('[data-product-container]');
    if (productContainer) {
      syncProductMoq(productContainer);
      syncVariantAvailability(productContainer);
      new MutationObserver(function () {
        syncProductMoq(productContainer);
        syncVariantAvailability(productContainer);
      })
        .observe(productContainer, { childList: true, subtree: true });
    }
  });

  document.addEventListener('click', function (event) {
    var isStickyAddToCart = event.target.closest('[data-sticky-addtocart]');
    var productContainer = event.target.closest('[data-product-container]') ||
      (isStickyAddToCart && document.querySelector('[data-product-container]'));
    if (!productContainer) return;
    if (event.target.closest('.dl-option-item')) {
      setTimeout(function () {
        syncProductMoq(productContainer);
        syncVariantAvailability(productContainer);
      }, 0);
    }
    if ((isStickyAddToCart || event.target.closest('.js-add-cart')) && !validateProduct(productContainer)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="updates[]"], .quantity__input')) {
      clampCartInput(event.target);
    }
    var productContainer = event.target.closest('[data-product-container]');
    if (productContainer && event.target.matches('[data-quantity-input]')) {
      syncProductMoq(productContainer);
      updateAddToCartTotal(productContainer);
      updateVolumeDiscountNote(productContainer);
      setTimeout(function () { syncVariantAvailability(productContainer); }, 0);
    }
  }, true);
})();
